import React from 'react';
import Container from '../Container';
import PricingCard from '../PricingCard';
import { pricingPlans } from '../../data/pricing';

export default function PricingSection() {
  return (
    <section id="tarifs" className="py-16 bg-white">
      <Container>
        <div className="text-center mb-4">
          <h2 className="text-xl md:text-[40px] font-inter leading-[50px] mb-3 tracking-[0%] font-bold text-[#191A15]">
            Des tarifs adaptés à vos besoins
          </h2>
          <p className="text-base md:text-lg text-[#A6A6A6]">Choisissez le modèle qui vous convient le mieux</p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-10 w-full mx-auto">
          {pricingPlans.map((plan) => (
            <PricingCard key={plan.id} plan={plan} featured={plan.featured} />
          ))}
        </div>
      </Container>
    </section>
  );
}
